module.exports = __webpack_public_path__ + "img/10979919_L.b3f21360.png";